(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const root = window.Shopify?.routes?.root || '/';
  const endpoint = path => root + path;
  let toastTimer;
  let saved = [];
  try { const value = JSON.parse(localStorage.getItem('dmure.shopify.saved') || '[]'); if (Array.isArray(value)) saved = value.filter(x => typeof x === 'string'); } catch { /* Browser storage is optional. */ }
  function toast(message) {
    const el = $('#toast'); if (!el) return;
    el.textContent = message; el.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('show'), 3200);
  }
  function open(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('modal-open'); return true;
  }
  function close(dialog) { if (dialog?.open) dialog.close(); }
  function refreshSaved() {
    $$('[data-save-product]').forEach(button => {
      const active = saved.includes(button.dataset.saveProduct);
      button.classList.toggle('saved', active); button.setAttribute('aria-pressed', String(active));
    });
  }
  async function request(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  }
  async function refreshCart() {
    const response = await fetch(endpoint('cart?section_id=dm-cart-drawer'), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Your bag was updated. Open the full bag to review it.');
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const content = $('#DmCartContents', doc);
    if (!content) throw new Error('Open the full bag to review your selection.');
    $('#DmCartContents').innerHTML = content.innerHTML;
    $('#DmCartContents').dataset.itemCount = content.dataset.itemCount;
    $$('[data-cart-count]').forEach(el => { el.textContent = content.dataset.itemCount || '0'; });
  }
  async function changeCart(input, quantity) {
    const line = input.closest('.bag-line');
    const error = $('.cart-error', $('#DmCartDrawer')); if (error) error.textContent = '';
    line?.classList.add('cart-line-busy');
    try {
      await request(endpoint('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: input.dataset.cartKey || input.dataset.cartRemove, quantity }) });
      await refreshCart();
    } catch (e) { if (error) error.textContent = e.message; toast(e.message); }
    finally { line?.classList.remove('cart-line-busy'); }
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (document.body.dataset.preview === 'true' && event.submitter?.name === 'checkout') { event.preventDefault(); toast('Checkout is inactive in store preview.'); return; }
    if (!form.matches('[data-product-form]')) return;
    event.preventDefault();
    const button = $('[data-add-button]', form), error = $('[data-product-error]', form);
    if (button.disabled) return;
    const text = button.textContent; button.disabled = true; button.textContent = 'Adding…'; error.textContent = '';
    let added = false;
    try {
      await request(endpoint('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      added = true;
      close($('#DmQuickView'));
      await refreshCart();
      if (!open($('#DmCartDrawer'))) location.assign(endpoint('cart'));
      toast('Added to your bag.');
    } catch (e) { if (added) { location.assign(endpoint('cart')); } else { error.textContent = e.message; } }
    finally { button.disabled = false; button.textContent = text; }
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (select) {
      const form = select.closest('[data-product-form]'), box = form.closest('[data-buy-box]');
      const variants = JSON.parse($('[data-variant-data]', form).textContent);
      const variant = variants.find(v => String(v.id) === select.value);
      if (!variant) return;
      const price = $('[data-product-price]', box); price.textContent = variant.price;
      if (variant.onSale) { const strike = document.createElement('s'); strike.className = 'muted'; strike.textContent = variant.comparePrice; price.append(' ', strike); }
      const button = $('[data-add-button]', form); button.disabled = !variant.available; button.textContent = variant.available ? 'Add to bag' : 'Sold out';
      const qty = $('[name="quantity"]', form); qty.min = variant.min || 1; qty.step = variant.step || 1;
      if (variant.max != null) qty.max = variant.max; else qty.removeAttribute('max'); qty.value = qty.min;
      $('[data-product-error]', form).textContent = '';
      const image = $('[data-main-product-image]', box.closest('[data-product-view]') || document);
      if (image && variant.image) { image.src = variant.image; image.removeAttribute('srcset'); }
      if (!box.closest('dialog')) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      return;
    }
    if (event.target.matches('[data-cart-key]') && event.target.closest('#DmCartDrawer')) {
      const quantity = Number(event.target.value);
      if (Number.isInteger(quantity) && quantity >= 0) changeCart(event.target, quantity);
    }
    if (event.target.closest('[data-auto-submit]') && !event.target.closest('.price-range')) event.target.form?.requestSubmit();
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('a,button'); if (!button) return;
    if (button.matches('[data-close]')) { close(button.closest('dialog')); return; }
    if (button.matches('[data-menu-open]')) { button.setAttribute('aria-expanded', 'true'); open($('#DmMenu')); return; }
    if (button.matches('[data-cart-open]') && typeof $('#DmCartDrawer')?.showModal === 'function') { event.preventDefault(); open($('#DmCartDrawer')); return; }
    if (button.matches('[data-product-quantity]')) {
      const input = $('[name="quantity"]', button.closest('form'));
      if (Number(button.dataset.productQuantity) > 0) input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', { bubbles: true })); return;
    }
    if (button.matches('[data-cart-remove]') && button.closest('#DmCartDrawer')) { event.preventDefault(); await changeCart(button, 0); return; }
    if (button.matches('[data-gallery-image]')) {
      const image = $('[data-main-product-image]', button.closest('[data-product-view]'));
      image.src = button.dataset.galleryImage; image.alt = button.dataset.galleryAlt || ''; image.removeAttribute('srcset'); return;
    }
    if (button.matches('[data-save-product]')) {
      const handle = button.dataset.saveProduct; saved = saved.includes(handle) ? saved.filter(x => x !== handle) : [...saved, handle];
      try { localStorage.setItem('dmure.shopify.saved', JSON.stringify(saved)); } catch { /* Optional storage. */ }
      refreshSaved(); toast(saved.includes(handle) ? 'Saved in this browser.' : 'Removed from saved pieces.'); return;
    }
    if (button.matches('[data-quick-product]') && typeof $('#DmQuickView')?.showModal === 'function') {
      event.preventDefault();
      const dialog = $('#DmQuickView'), content = $('#DmQuickContent');
      try {
        button.setAttribute('aria-busy', 'true');
        const url = new URL(button.href, location.origin); url.searchParams.set('section_id', 'dm-main-product');
        const response = await fetch(url, { credentials: 'same-origin' }); if (!response.ok) throw new Error();
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const box = $('[data-buy-box]', doc), image = $('[data-main-product-image]', doc); if (!box) throw new Error();
        content.innerHTML = ''; const layout = document.createElement('div'); layout.className = 'quick-layout';
        if (image) { const photo = image.cloneNode(true); photo.removeAttribute('id'); layout.appendChild(photo); }
        const copy = box.cloneNode(true);
        $$('[id]', copy).forEach(el => { const old = el.id; el.id = old + '-quick'; $$('[for]', copy).filter(label => label.htmlFor === old).forEach(label => { label.htmlFor = el.id; }); });
        const title = $('h1', copy); if (title) title.id = 'DmQuickTitle';
        const details = document.createElement('a'); details.href = button.href; details.className = 'text-link'; details.textContent = 'View full details ↗'; copy.appendChild(details);
        layout.appendChild(copy); content.appendChild(layout); open(dialog);
      } catch { location.assign(button.href); }
      finally { button.removeAttribute('aria-busy'); }
    }
  });
  document.addEventListener('close', event => {
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
    if (event.target.id === 'DmMenu') $('[data-menu-open]')?.setAttribute('aria-expanded', 'false');
  }, true);
  document.addEventListener('click', event => {
    const dialog = event.target; if (dialog.tagName !== 'DIALOG') return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(dialog);
  });
  document.addEventListener('shopify:section:load', refreshSaved);
  refreshSaved();
})();
